import { FormRenderer } from '@data-driven-forms/react-form-renderer';
import { PrizeetMappers } from '../../../schema/custom-form/prizeet-mappers';
import { ProductVariantSchema, ProductVariantSchemaData } from '../../../schema/data/product-variant.schema';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useMemo, useState } from 'react';
import { ProductVariantFormTemplate } from './ProductVariantFormTemplate';
import { IFormProps } from '../../../interface/interface';
import { API } from '../../../config/config';
import { useAuth } from '../../../hooks/useAuth';

// Cache for product name to avoid unnecessary fetches
let cachedProductName = null;

export interface ProductVariantCreateProps extends IFormProps<ProductVariantSchemaData> {
  onChange?: (data: { key: string, value: any }) => void;
}

export const CreateProductVariantForm = (props: ProductVariantCreateProps) => {
  const { enhancedFetch } = useAuth();
  const { onSubmit, data, onClose, fullWidth, title, isLoading, openModal, maxWidth, editModal, editData, onChange } = props;
  const [schema, setSchema] = useState<any>(null);

  // Create initial schema
  let _schema = useMemo(() => ProductVariantSchema({
    ...data,
    editData: editModal ? editData : null
  }), [editModal, openModal]);

  useEffect(() => {
    setSchema(_schema);
  }, [_schema]);

  // Handler for product selection change
  const handleProductChange = async (value: string) => {
    if (cachedProductName === value) return;

    const response = await enhancedFetch(`${API.HOST}/api/v1/products/${value}`, {
      method: 'GET'
    });

    const new_schema = (ProductVariantSchema({
      ...data,
      editData: {
        ...editData,
        ...{
          product: {
            ...response
          }
        }
      }
    }));

    cachedProductName = value;
    onChange && onChange({ key: 'productName', value });
    setSchema(new_schema);
  };

  return (
    <>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={openModal || editModal}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {schema && (
            <FormRenderer
              componentMapper={{ ...PrizeetMappers }}
              schema={schema}
              FormTemplate={(data) => (
                <ProductVariantFormTemplate
                  formFields={data.formFields}
                  onSubmit={props.onSubmit}
                  onChange={handleProductChange}
                />
              )}
              subscription={{ values: true }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
